// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"0ec1c879","850":"51155a71"}[chunkId] + ".bundle.js";
};